import { render, staticRenderFns } from "./DetailsSeedExpert.vue?vue&type=template&id=45a19f16&scoped=true&"
import script from "./DetailsSeedExpert.vue?vue&type=script&lang=js&"
export * from "./DetailsSeedExpert.vue?vue&type=script&lang=js&"
import style0 from "./DetailsSeedExpert.vue?vue&type=style&index=0&id=45a19f16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a19f16",
  null
  
)

export default component.exports